import { Box, Grid, Text } from '@shared/components';
import type { PropsWithChildren } from '@shared/utils';

export interface GridRowProps extends PropsWithChildren {
  label: string;
}

export default function GridRow(props: Readonly<GridRowProps>) {
  const { label, children } = props;

  return (
    <Grid
      sx={(theme) => ({
        gridTemplate: '1fr / 200px 1fr',
        gap: theme.spacing(8),
        gridAutoFlow: 'row dense',
      })}
    >
      <Text variant='body2Semibold'>{label}</Text>
      <Box>{children}</Box>
    </Grid>
  );
}
